import { ProviderWorkPlace as ProviderWorkPlaceResponse } from '@/DTOS/ProviderWorkPlace/Response/ProviderWorkPlace';
import { Button, Tooltip } from 'antd';
import React from 'react';
import { EditOutlined} from '@ant-design/icons';

export const ProviderWorkPlaceColumn = (handleEdit: (record: ProviderWorkPlaceResponse) => void) => [
  
  {
    title: 'Id',
    dataIndex: 'id',
    key: 'id',
    hidden: true,
  },
  {
    title: 'Client',
    dataIndex: ['provider', 'name'],
    key: 'providerName',
    width: 200,
  },
  {
    title: 'Denumire',
    dataIndex: 'name',
    key: 'name',
    width: 200,
     render: (text: string) => (
              <Tooltip title={text}>
                <div className="ellipsis-cell">{text}</div>
              </Tooltip>
            )
  },
  
  {
    title: 'Adresa',
    dataIndex: 'address',
    key: 'address',
    width: 150,
    render: (record: string | undefined) => (
          <Tooltip title={record}>
            <div className="ellipsis-cell">{record ? record : "-"}</div>
          </Tooltip>
        ),
  },
  {
    title: 'Detalii',
    dataIndex: 'details',
    key: 'details',
    width:200,
     render: (record: string | undefined) => (
          <Tooltip title={record}>
            <div className="ellipsis-cell">{record ? record : "-"}</div>
          </Tooltip>
        ),
  },
  {
    title: 'Actiune',
    key: 'actions',
    render: (record: ProviderWorkPlaceResponse) => (
      <div className='action-column'>
        <Tooltip title="Modifica">
        <Button className='modify-button' onClick={() => handleEdit(record)} icon={<EditOutlined/>}>
        </Button>
        </Tooltip>
      </div>
    ),
    width: 120,
    fixed: 'right',
  },
];
